"use client";

import { c as _c } from "react/compiler-runtime";
import { createComment } from "@/actions/comment";
import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { queryClient } from "@/providers/react-query";
import { TContentType } from "@/types/types";
import { commentCreateSchema } from "@/types/zod-types";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
import { Textarea } from "../ui/textarea";
import ButtonWithLoader from "../utility/button-with-loader";
type CommentFormProps = {
  contentType: TContentType;
  contentId: string;
};
export default function CommentForm(t0) {
  const $ = _c(23);
  const {
    contentType,
    contentId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(commentCreateSchema),
      defaultValues: {
        content: ""
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  const {
    control,
    handleSubmit,
    reset,
    formState: t2
  } = form;
  const {
    isDirty,
    isSubmitting
  } = t2;
  const {
    userId
  } = useAuth();
  let t3;
  if ($[1] !== contentId || $[2] !== contentType || $[3] !== reset || $[4] !== userId) {
    t3 = async function handleCreateComment(formData) {
      if (!userId) {
        toast.warning("Please sign in to add a comment.");
        return;
      }
      const {
        error
      } = await tryCatch(createComment(contentType, contentId, formData));
      if (error) {
        toast.error(error.message);
        return;
      }
      reset();
      queryClient.invalidateQueries({
        queryKey: [`get-comments:${contentType}:${contentId}`]
      });
      toast.success("Comment added.");
    };
    $[1] = contentId;
    $[2] = contentType;
    $[3] = reset;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCreateComment = t3;
  let t4;
  if ($[6] !== handleCreateComment || $[7] !== handleSubmit) {
    t4 = handleSubmit(handleCreateComment);
    $[6] = handleCreateComment;
    $[7] = handleSubmit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== control) {
    t5 = <FormField control={control} name="content" render={_temp} />;
    $[9] = control;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = !isDirty || isSubmitting;
  let t7;
  if ($[11] !== isSubmitting || $[12] !== t6) {
    t7 = <ButtonWithLoader type="submit" pending={isSubmitting} disabled={t6}>Submit</ButtonWithLoader>;
    $[11] = isSubmitting;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="flex flex-col items-end gap-2">{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <form onSubmit={t4}>{t8}</form>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== form || $[21] !== t9) {
    t10 = <Form {...form}>{t9}</Form>;
    $[20] = form;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Textarea {...field} value={field.value || ""} rows={3} placeholder="Add your comment..." /></FormControl></FormItem>;
}